import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["selector"];
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Pagination from "../Pagination";
import { jsx as _jsx } from "react/jsx-runtime";
var DesktopPagination = function DesktopPagination(_ref) {
  var selector = _ref.selector,
    desktopPaginationProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var nodeRef = useRef(null);
  useEffect(function () {
    if (selector) {
      var node = document.querySelector(selector);
      nodeRef.current = node;
      setLoading(false);
    }
  }, [selector]);
  if (!loading && nodeRef.current) {
    return /*#__PURE__*/ReactDOM.createPortal(
    /*#__PURE__*/
    // @ts-ignore
    _jsx(Pagination, _objectSpread({}, desktopPaginationProps)), nodeRef.current);
  }
  return null;
};
export default DesktopPagination;